export default {
      id: "ar_menus-usage",
      viewBox: "0 0 90 90",
      url: "../dist/images/" + "sprite.svg#ar_menus-usage",
      toString: function () {
        return this.url;
      }
    }